import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Container,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem
} from '@mui/material';
import { Menu as MenuIcon, Language as LanguageIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
];

const Header: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [langMenuAnchor, setLangMenuAnchor] = useState<null | HTMLElement>(null);
  const { t, i18n } = useTranslation();

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLangMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setLangMenuAnchor(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangMenuAnchor(null);
  };

  const handleLanguageChange = (code: string) => {
    i18n.changeLanguage(code);
    handleLangMenuClose();
  };

  const navItems = [
    { titleKey: 'nav.home', path: '/' },
    { titleKey: 'nav.services', path: '/services' },
    { titleKey: 'nav.about', path: '/about' },
    { titleKey: 'nav.team', path: '/team' },
    { titleKey: 'nav.careers', path: '/careers' },
    { titleKey: 'nav.contact', path: '/contact' },
  ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
        <img src="/WhatsApp Image 2026-03-30 at 22.24.44.jpeg" alt="Desiree African Hair Braiding" style={{ height: 50 }} />
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.titleKey} disablePadding>
            <ListItemButton
              component={RouterLink}
              to={item.path}
              sx={{ textAlign: 'center' }}
            >
              <ListItemText primary={t(item.titleKey)} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="static" color="default" elevation={0} sx={{ bgcolor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Toolbar disableGutters>
            <Box
              component={RouterLink}
              to="/"
              sx={{
                mr: 2,
                display: { xs: 'none', sm: 'flex' },
                alignItems: 'center',
                textDecoration: 'none',
                flexGrow: isMobile ? 0 : 1,
              }}
            >
              <img src="/WhatsApp Image 2026-03-30 at 22.24.44.jpeg" alt="Desiree African Hair Braiding" style={{ height: 50 }} />
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', sm: 'none' } }}>
              <IconButton
                size="large"
                aria-label="menu"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleDrawerToggle}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
            </Box>

            <Box
              component={RouterLink}
              to="/"
              sx={{
                flexGrow: 1,
                display: { xs: 'flex', sm: 'none' },
                justifyContent: 'center',
                textDecoration: 'none',
              }}
            >
              <img src="/WhatsApp Image 2026-03-30 at 22.24.44.jpeg" alt="Desiree African Hair Braiding" style={{ height: 40 }} />
            </Box>

            {/* Desktop Navigation */}
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              {navItems.map((item) => (
                <Button
                  key={item.titleKey}
                  component={RouterLink}
                  to={item.path}
                  sx={{ color: 'text.primary', mx: 1 }}
                >
                  {t(item.titleKey)}
                </Button>
              ))}
            </Box>

            {/* Language Switcher */}
            <IconButton
              onClick={handleLangMenuOpen}
              color="inherit"
              aria-label="change language"
              sx={{ ml: 1 }}
            >
              <LanguageIcon />
            </IconButton>
            <Menu
              anchorEl={langMenuAnchor}
              open={Boolean(langMenuAnchor)}
              onClose={handleLangMenuClose}
            >
              {languages.map((lang) => (
                <MenuItem
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  selected={i18n.language === lang.code}
                >
                  {lang.label}
                </MenuItem>
              ))}
            </Menu>

            {/* Book Now Button */}
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              to="/booking"
              sx={{
                ml: 2,
                display: { xs: 'none', sm: 'block' },
                color: 'text.primary',
                fontWeight: 500,
              }}
            >
              {t('nav.bookNow')}
            </Button>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Header;
